<app-layout>
  <div class="row">
    <div class="col-12" *ngIf="talepOnaySeviye">
      <div class="card">
        <div class="card-header">
          <h4 class="card-title">{{id === '0' ? 'Yeni Talep Onay Seviye' : 'Talep Onay Seviye Düzenle'}}</h4>
          <div class="card-options">
            <div class="btn btn-sm btn-pill btn-success" (click)="save()">
              Kaydet
            </div>
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <div class="mb-3">
                <div class="form-label">Seviye</div>
                <input type="number" class="form-control" placeholder="Seviye" [(ngModel)]="talepOnaySeviye.seviye">
              </div>
              <div class="mb-3">
                <div class="form-label">Talep Türü</div>
                <app-loading-input *ngIf="!talepTurler"></app-loading-input>
                <select *ngIf="talepTurler" class="form-control" [(ngModel)]="talepOnaySeviye.talepTurId"
                        [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let p of talepTurler" [ngValue]="p.id">{{p.isim}}</option>
                </select>
              </div>
              <div class="mb-3">
                <div class="form-label">Kullanıcı Grupları</div>
                <app-loading-input *ngIf="!kullaniciGruplar"></app-loading-input>
                <select *ngIf="kullaniciGruplar" class="form-control" [(ngModel)]="talepOnaySeviye.kullaniciGrupId"
                        [ngModelOptions]="{standalone: true}">
                  <option [value]="null" disabled selected>Şeçiniz</option>
                  <option *ngFor="let p of kullaniciGruplar" [ngValue]="p.id">{{p.isim}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</app-layout>
